/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard API
 * API to get important events relevant for logged-in user
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The registration status
 * @export
 */
export const Status = {
    ForApproval: 'FOR_APPROVAL',
    Approved: 'APPROVED',
    Rejected: 'REJECTED',
    CompanyRegistered: 'COMPANY_REGISTERED'
} as const;
export type Status = typeof Status[keyof typeof Status];


export function StatusFromJSON(json: any): Status {
    return StatusFromJSONTyped(json, false);
}

export function StatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): Status {
    return json as Status;
}

export function StatusToJSON(value?: Status | null): any {
    return value as any;
}

